import { proxy } from "valtio";
import { apiReleaseLock } from "../apis/lock/release.lock";

//

export enum WeddnAppResource {
  WeddnAppResourcesUpdateEditor = "weddn_app_resources_update_editor",
  WeddnAppResourcesGuest = "weddn_app_resources_guest",
  WeddnAppResourcesCountdown = "weddn_app_resources_countdown",
}

type LockStore = {
  [WeddnAppResource.WeddnAppResourcesGuest]: boolean;
  [WeddnAppResource.WeddnAppResourcesCountdown]: boolean;
  [WeddnAppResource.WeddnAppResourcesUpdateEditor]: boolean;
  setLock: (resource: WeddnAppResource) => void;
  releaseLock: (resource: WeddnAppResource) => void;
};

export const lockStore = proxy<LockStore>({
  [WeddnAppResource.WeddnAppResourcesUpdateEditor]: false,
  [WeddnAppResource.WeddnAppResourcesGuest]: false,
  [WeddnAppResource.WeddnAppResourcesCountdown]: false,
  setLock(resource) {
    this[resource] = true;
  },
  releaseLock(resource) {
    this[resource] = false;
  },
});

export const GlobalLockRelease = async (resource: WeddnAppResource) => {
  try {
    await apiReleaseLock({
      params: resource,
      onCompleted() {
        lockStore.setLock(resource);
      },
      onError(err) {
        console.error(err);
        lockStore.releaseLock(resource);
      },
    });
    lockStore.releaseLock(resource);
  } catch (err) {
    console.error(err);
  }
};
